export const PROFILE_LINK_PENDING = "PROFILE_LINK_PENDING";
export const PROFILE_LINK_SUCCESS = "PROFILE_LINK_SUCCESS";
export const PROFILE_LINK_ERROR = "PROFILE_LINK_ERROR";

export function fetchProfileLinkPending() {
  return {
    type: PROFILE_LINK_PENDING,
  };
}

export function fetchProfileLinkSuccess(payload) {
  return {
    type: PROFILE_LINK_SUCCESS,
    payload: payload,
  };
}

export function fetchProfileLinkError(error) {
  return {
    type: PROFILE_LINK_ERROR,
    error: error,
  };
}
